import styled, { css } from 'styled-components/macro'
import Text from 'components/shared/Text'
import { Wrapper as Icon } from 'components/shared/Icon/styles'
import { LinkVariant } from 'styles/types'

interface WrapperProps {
    variant: LinkVariant
    isDisabled: boolean
    isUnderlined?: boolean
}

export const Wrapper = styled.a<WrapperProps>`
    ${({ theme, isDisabled }) =>
        isDisabled &&
        css`
            pointer-events: none;
            cursor: default;

            ${Icon}, ${Text} {
                color: ${theme.colors.grayscale_500} !important;
            }
        `}
    ${({ isUnderlined }) =>
        isUnderlined &&
        css`
            ${Text} {
                text-decoration: underline;
            }
        `}

    ${({ isUnderlined, variant }) =>
        isUnderlined &&
        css`
            text-decoration: underline;
            text-decoration-color: ${variant};
        `}

    display: inline-block;

    ${Text}, ${Icon} {
        color: ${({ theme, variant }) => theme.linkVariants[variant].textColor};
    }

    ${Text} {
        transition: color 100ms ease-in;
    }

    &:hover {
        ${Text}, ${Icon} {
            color: ${({ theme, variant, isDisabled }) =>
                isDisabled
                    ? theme.colors.grayscale_500
                    : theme.linkVariants[variant].textColorHover};
        }
    }

    &:focus-visible,
    &:active {
        ${Icon}, ${Text} {
            color: ${({ theme, variant, isDisabled }) =>
                isDisabled
                    ? theme.colors.grayscale_500
                    : theme.linkVariants[variant].textColorActive};
        }
    }
`
